import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { toPaymentRequestWriteBody } from './serialize';

/**
 * POST `/fms/payment-requests` → 201。
 * 禁送 payeeId／totalAmount／requestNo／status。
 */
export async function createPaymentRequest(payload) {
  const { data: raw } = await request.post(
    '/fms/payment-requests',
    toPaymentRequestWriteBody(payload),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}
